import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { ReadOnlyType, SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { TileViewComponent } from 'ui/tile-view/tile-view';
import { SafetyLimitTile } from 'app/area/codetable/item/screen-renderer/screen-pickers/safety-limits/tile/safety-limit-tile';
import { SafetyLimitAddButton } from 'app/area/codetable/item/screen-renderer/screen-pickers/safety-limits/safety-limit-add-button';
import styles from './safety-limits.scss';

export const SafetyLimits = (props: Partial<CodetableItemFormComponentProps> & SlotProps &
{ codeCategoryLabel?: (translation: CodetableTranslation) => string }) => {

  const { breadcrumbs, translation, sectionSlots, sectionRef, codeItem, clearByKey, readOnlyConfig, updateByKey, removeSafetyLimit,
    resetValidation, updateValidation, options, loadOptions, validation, updateSafetyLimit
  } = props;

  const readOnly = readOnlyConfig?.[ReadOnlyType.all];

  const safetyLimit = codeItem?.safetyLimit ?? [];

  const existingKeys = safetyLimit.map(item => item.application);

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="safety-limits"
      validation={undefined}
      info={{ text: translation.safety_limits }}
      label={{ visible: true, text: translation.safety_limits }} />
    <MainGridContainer>
      <div className="row">
        {renderSlot(sectionSlots, 'top', props)}
        {
          safetyLimit.length === 0 && readOnly
            ? <div className={`no-content ${styles.noSafetyLimits}`}>{translation.no_safety_limits}</div>
            : <TileViewComponent
              componentId="safety-limit-tile"
              className={styles.tileViewComponent}
              textAddItem={undefined}
              label={{ required: false, visible: false }}
              readOnly={readOnly}
              enabledChildEntityOperations={{ add: true }}
              addButton={<SafetyLimitAddButton
                breadcrumbs={breadcrumbs}
                existingKeys={existingKeys}
                options={options}
                updateByKey={updateByKey}
                clearByKey={clearByKey}
                codetableOptions={undefined}
                codeItem={codeItem}
                resetValidation={resetValidation}
                updateValidation={updateValidation}
                loadCodetableOptions={undefined}
                loadOptions={loadOptions}
                translation={translation} />}>
              {safetyLimit.map((item, index) =>
                <SafetyLimitTile
                  key={index}
                  breadcrumbs={breadcrumbs}
                  safetyLimit={item}
                  clearByKey={clearByKey}
                  codetableOptions={undefined}
                  updateByKey={updateByKey}
                  codeItem={codeItem}
                  resetValidation={resetValidation}
                  updateValidation={updateValidation}
                  loadCodetableOptions={undefined}
                  loadOptions={loadOptions}
                  translation={translation}
                  validation={validation}
                  readOnlyConfig={readOnlyConfig}
                  removeSafetyLimit={removeSafetyLimit}
                  updateSafetyLimit={updateSafetyLimit} />)
              }
            </TileViewComponent>
        }
        {renderSlot(sectionSlots, 'bottom', props)}
      </div>
    </MainGridContainer>
  </div>;
};
